var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.connlu && _vm.renderTree
    ? _c("reactive-dep-tree", {
        ref: "tree",
        attrs: {
          minimal: "",
          interactive: "",
          "shown-features": _vm.shownFeatures,
          conll: _vm.connlu,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }